import { render, staticRenderFns } from "./ProductNotAvailable.vue?vue&type=template&id=6236d500&scoped=true&"
import script from "./ProductNotAvailable.vue?vue&type=script&lang=js&"
export * from "./ProductNotAvailable.vue?vue&type=script&lang=js&"
import style0 from "./ProductNotAvailable.vue?vue&type=style&index=0&id=6236d500&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6236d500",
  null
  
)

export default component.exports